import React from 'react';
import DashboardCard from '../shared/DashboardCard';
import EmptyState from '../shared/EmptyState';
import styles from '../../../../styles/DashboardV2.module.css';

interface RiskAgent {
    id?: string;
    name?: string;
    completionRate?: number;
}

interface AtRiskAgentsWidgetProps {
    agents: RiskAgent[];
    threshold?: number;
    loading?: boolean;
}

const AtRiskAgentsWidget: React.FC<AtRiskAgentsWidgetProps> = ({
    agents,
    threshold = 70,
    loading,
}) => {
    const getName = (a: RiskAgent) =>
        a.name ?? 'Unknown Agent';

    return (
        <DashboardCard
            title={`At Risk Agents (below ${threshold}%)`}
            loading={loading}
        >
            {agents.length === 0 ? (
                <EmptyState
                    icon="✅"
                    message={`No agents below ${threshold}% compliance.`}
                />
            ) : (
                <div className={styles.itemList}>
                    {agents.map((agent, i) => (
                        <div
                            key={agent.id ?? i}
                            className={styles.riskRow}
                        >
                            <div className={styles.riskRowInfo}>
                                <div className={styles.riskRowName}>{getName(agent)}</div>
                            </div>
                            {agent.completionRate !== undefined && (
                                <div className={styles.riskRowPct}>
                                    {agent.completionRate.toFixed(0)}%
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </DashboardCard>
    );
};

export default AtRiskAgentsWidget;
